import { ref, get } from "firebase/database";
import { PaymentData } from "../../models/payment";
import { db } from "../firebaseConfig";

/**
 * Get Payments by Date Range
 * @param startDate : Start Date in IST
 * @param endDate : End Date in IST
 * @returns : List of payments if found
 */
export const getPaymentsByDateRange = async (
	startDate: string,
	endDate: string
): Promise<PaymentData[]> => {
	try {
		const paymentsRef = ref(db, "payments");
		const snapshot = await get(paymentsRef);
		if (!snapshot.exists()) {
			return [];
		}
		const payments = snapshot.val() as { [key: string]: PaymentData };
		const filteredPayments: PaymentData[] = [];
		Object.values(payments).forEach((payment) => {
			const paymentDate = payment.paymentDate.substring(0, 10);
			if (paymentDate >= startDate && paymentDate <= endDate) {
				filteredPayments.push(payment);
			}
		});
		return filteredPayments;
	} catch (error) {
		console.error("Error fetching payments by date range:", error);
		throw error;
	}
};
